import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { LoadingIcon } from "../../../themes/userq/Loader/loadingIcon";
import { Button } from "../Button/Button";
import { CheckBox } from "../CheckBox/CheckBox";
import { Icon } from "../Icon/Icon";
import { Text } from "../Text/Text";
import { IncDecCounter } from "../IncDecCounter/IncDecCounter";
import { Box } from "../Box/Box";
import { RadioButton } from "../RadioButton/RadioButton";
import { RecruitmentSlider } from "../RecruitmentSlider/RecruitmentSlider";

export default function ReportTypeModal({
    openModal,
    close,
    testers_count,
    confirm,
}) {
    const [formValues, setFormValues] = useState({
        report_type: "",
        testers: testers_count,
    });

    useEffect(() => {
        setFormValues({
            ...formValues,
            report_type: "",
            testers: testers_count,
        });
    }, [openModal]);

    const closeModal = () => {
        close();
    };
    const wrapperRef = useRef(null);

    const navigate = useNavigate();

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if (event.target.nodeName == "DIV") {
                        closeModal();
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    return (
        <Modal
            show={openModal}
            centered
            className={`fade custom-modal-wrap  confirmation-modal-wrap report-type-modal`}
            backdropClassName="report-recruit-modal-wrapper"
        >
            <Modal.Body className="" ref={wrapperRef}>
                <div className="modal-inner-text">
                    <div className="modal-header-top">
                        <Text type={"h3"}>
                            Report participants ({testers_count})
                        </Text>

                        <button
                            type="button"
                            className="close"
                            onClick={() => {
                                closeModal();
                            }}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">
                                <Icon
                                    value="Close"
                                    size="medium"
                                    hover={true}
                                />
                            </span>
                        </button>
                    </div>

                    <div className={"report-tester-confirmation-data-wrap"}>
                        <div className="mb-20">
                            <Text type={"body-text-3"} fontWeight={"medium-font"} cssClasses={"gray-text"}>
                                Choose how you'd like to proceed with the reported participants:
                            </Text>
                        </div>
                        <div className="mb-20">
                            <Box
                                size={"large"}
                                cssClasses={`${
                                    formValues.report_type ==
                                    "Report and refund"
                                        ? "active-box"
                                        : ""
                                }`}
                            >
                                <RadioButton
                                    isChecked={
                                        formValues.report_type ==
                                        "Report and refund"
                                            ? true
                                            : false
                                    }
                                    label={"Report and refund"}
                                    sublabel={
                                        "Credits will be refunded to your wallet once we approve your request."
                                    }
                                    onChange={() => {
                                        setFormValues({
                                            ...formValues,
                                            report_type: "Report and refund",
                                        });
                                    }}
                                />
                            </Box>
                        </div>
                        <div>
                            <Box
                                size={"large"}
                                cssClasses={`${
                                    formValues.report_type ==
                                    "Report and recruit"
                                        ? "active-box"
                                        : ""
                                }`}
                            >
                                <RadioButton
                                    isChecked={
                                        formValues.report_type ==
                                        "Report and recruit"
                                            ? true
                                            : false
                                    }
                                    label={"Report and recruit"}
                                    sublabel={
                                        "Recruit more participants to replace reported participants."
                                    }
                                    onChange={() => {
                                        setFormValues({
                                            ...formValues,
                                            report_type: "Report and recruit",
                                        });
                                    }}
                                />

                                <div className="estimate-count-area inc-dec-holder">
                                    <IncDecCounter
                                        value={formValues.testers}
                                        min={testers_count}
                                        max={1000}
                                        onChange={(value) => {
                                            setFormValues({
                                                ...formValues,
                                                testers: value,
                                            });
                                        }}
                                        readOnly={false}
                                    />
                                </div>
                            </Box>
                        </div>
                    </div>

                    <div className="confirm-buttons-wrap d-flex justify-content-center mt-32">
                        <Button
                            type="primary"
                            size={"large"}
                            label="Continue"
                            state={
                                formValues.report_type &&
                                formValues.report_type != ""
                                    ? "active"
                                    : "disabled"
                            }
                            onClick={() => {
                                if (
                                    formValues.report_type &&
                                    formValues.report_type != ""
                                ) {
                                    confirm(formValues);
                                }
                            }}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
